import { render, staticRenderFns } from "./props.vue?vue&type=template&id=6d055353&scoped=true&"
import script from "./props.vue?vue&type=script&lang=js&"
export * from "./props.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d055353",
  null
  
)

export default component.exports